export enum ErrorCodesAPI {
    CemUserAuthorizationsFetchingError = 'E107',
    UnhandledError = 'E108'
}

export enum ErrorCodesUI {
    //General
    NoClientsForApplication = 'U001',
    NoDataToDisplay = 'U002',
    SortingError = 'U003',
    ServerSideError = 'U004',
    NotClientAdmin = 'U005',
    NoClientSelected = 'U006',
    AccessForbidden = 'U007',
    NoEngagementSelected = 'U008',
    NoEngagementsForClient = 'U009',

    //User Dashboard
    InvalidApplicationId = 'U100',

    //Reports
    PowerBiDisplayReportError = 'U200',
    HierarchyDropdownEmptyError = 'U201',
    ShareReportEmailError = 'U202',
    StoreUserHierarchyError = 'U203',
    CardDataError = 'U204',
    ShareReportCopyLinkError = 'U205',
}

export const GetApiErrorCode = (error:any)=>{
    if(error.isApiException){
        error = JSON.parse(error.response);
    }
    if(error.errors){
        error = error.errors;
    }
    else if(error.error){
        errorMessage = error.error;
        var errorCode = errorMessage.split(' - ')[0];
        return errorCode;
    }

    const arrayErrors: string[] = Object.keys(error).reduce((errs: string[], key) => {
        const messages = Array.isArray(error[key])
        ? error[key]
        : error[key]?.value?.errors?.map((e: { errorMessage: string }) => e.errorMessage) || [];
        if (Array.isArray(messages)) {
            errs.push(...messages);
        } else if (messages) {
            errs.push(messages);
        }
        return errs;
    }, []);

    var errorMessage = arrayErrors[0];
    if(!errorMessage.match(' - ')){
        return ErrorCodesAPI.UnhandledError;;
    }
    var errorCode = errorMessage.split(' - ')[0];
    return errorCode;
}
